(function ($) {
	var interval = setInterval(function () {
		if (document.readyState === 'complete') {
			clearInterval(interval);
			console.log(document.readyState);
			setTimeout(function () {
				$(".progress").fadeOut(500);
				AOS.init({
					once: true,
					// disable: 'mobile',
				});
			}, 500);
		}
	}, 100);

	$('.checkOut-row img').click(function () {
		$(this).parent().slideUp()
	})
})(jQuery);
